import Image from 'next/image'
import { useEffect, useRef, useState } from 'react'
import styles from './ImageComparisonSlider.module.scss'

const ImageComparisonSlider = ({ image1, image2 }) => {
  const [isSliding, setIsSliding] = useState(false)
  const [slidePosition, setSlidePosition] = useState(30.4675)
  const containerRef = useRef(null)

  const startSliding = () => setIsSliding(true)
  const stopSliding = () => setIsSliding(false)

  const handleSlide = (x) => {
    if (containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect()
      const offsetX = x - containerRect.left

      let percentage = (offsetX / containerRect.width) * 100
      percentage = Math.max(0, Math.min(percentage, 100))
      setSlidePosition(percentage)
    }
  }

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isSliding) {
        handleSlide(e.clientX)
      }
    }

    const handleTouchMove = (e) => {
      if (isSliding) {
        handleSlide(e.touches[0].clientX)
      }
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', stopSliding)
    document.addEventListener('touchmove', handleTouchMove)
    document.addEventListener('touchend', stopSliding)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', stopSliding)
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('touchend', stopSliding)
    }
  }, [isSliding])

  return (
    <div className={styles.imageComparisonContainer} ref={containerRef}>
      <div className={styles.imageComparisonOverlay} style={{ width: `${slidePosition}%` }}>
        <Image src={image1} alt="Image 1" height={600} width={600} objectFit="contain" />
      </div>
      <Image src={image2} alt="Image 2" height={600} width={600} objectFit="contain" />
      <div className={styles.slider} style={{ left: `${slidePosition}%` }} onMouseDown={startSliding} onTouchStart={startSliding} />
    </div>
  )
}

export default ImageComparisonSlider
